import React, { useEffect, useState } from "react";
import { useSnackbar } from 'notistack';
import { browserHistory, withRouter } from 'react-router'
import moment from "moment";
import { Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Menu, MenuItem, Chip, Tooltip, Checkbox } from "@material-ui/core";
import { STableLoader, PageLoader, EmptyCollection, FilterComponent, DeletePopUp } from '../../shared_elements';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import EditIcon from '@material-ui/icons/Edit';
import  AddAssembly from './AddAssembly';
import  LinkAssembly from './LinkAssembly';
import UnlinkAssembly from './UnlinkAssembly';
import { globalGetService, globalPostService } from '../../../globalServices';
import { displayDateFormatShort, imgStoragePath } from "../../../constants";
import { checkApiStatus, checkPermission, getLocalStorageInfo } from '../../utils_v2';
import { assemblyTypeObj, maFilterOps } from '../'
import appConfig from "../../../config";
import ActiveLeasePopUp from "./ActiveLeasePopUp";
import { gaTelesisInstance, mtInstance } from "../../../shared/components";
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const AssemblyMenu = ({assetInfoData, onClickAssembly, btnLabel}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return(
        <>
            <Button color="primary" size="small" variant="contained" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} endIcon={<ArrowDropDownIcon fontSize="small" />}>
                {btnLabel}
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                style={{marginTop:'42px'}}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => {handleClose(); onClickAssembly({type:2, label:'Engine'})}}>Engine</MenuItem>
                {assetInfoData?.aircraft_type?.has_propeller && !gaTelesisInstance ?
                    <MenuItem onClick={() => {handleClose(); onClickAssembly({type:5, label:'Propeller'})}}>Propeller</MenuItem>:null
                }
                { assetInfoData?.aircraft_type?.has_apu ?
                    <MenuItem onClick={() => {handleClose(); onClickAssembly({type:3, label:'APU'})}}>APU</MenuItem>:null
                }
                <MenuItem onClick={() => {handleClose(); onClickAssembly({type:4, label:'Landing Gear'})}}>Landing Gear</MenuItem>
            </Menu>
        </>
    )
}
const MajorAssemblies = ({params, assetInfoData}) => {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [majorAssemblyInfo, setMajorAssemblyInfo] = useState({list:[], pagination:null});
    const [assetHasLgSubAssemblies, setAssetHasLgSubAssemblies] = useState(false);
    const [addEditAssembly, setAddEditAssembly] = useState({modal:false, data:null});
    const [linkAssembly, setLinkAssembly] = useState({modal:false, data:null});
    const [unlinkAssembly, setUnlinkAssembly] = useState({modal:false, data:null})
    const [activeLeaseModal, setActiveLeaseModal] = useState({modal:false, data:null})
    const [filter, setFilter]= useState({})
    const [lgGroupModal, setLgGroupModal]= useState({})
    const [groupError, setGroupError]= useState({})
    useEffect(() => {
        getMajorAssemblies('skeletonLoader');
    }, []);
    const getMajorAssemblies = (loaderType, query) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true);
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/major-assemblies/`,query)
        .then(response => {
            if(checkApiStatus(response)){
                setMajorAssemblyInfo(response.data.data);
                setAssetHasLgSubAssemblies(response.data.asset_has_lg_sub_assemblies);
                if( query){
                    setFilter(query)
                }
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false):setLoading(false);
        })
    }
    const onEditAssembly = (assembly) => {
        let formData = {
            asset: {id:assembly.id, slug:assembly.slug, asset_type:assemblyTypeObj[assembly.major_assembly_type], asset_name:assembly?.major_assembly_name||''},
            is_assigned:assembly?.is_assigned,
            is_fitted:assembly?.is_fitted,
            is_billable:assembly?.is_billable,
            is_titled:assembly?.is_titled,
            on_wing_aircraft:assembly?.on_wing_aircraft,
            off_wing_status:assembly?.off_wing_status,
            on_wing_status:assembly?.on_wing_status,
            sub_assembly:assembly?.sub_assembly,
            installation_date:assembly?.installation_date,
            removal_date:assembly?.removal_date,
            csn_at_movement:assembly?.csn_at_movement,
            tsn_at_movement:assembly?.tsn_at_movement,
            records_movement:false,
            wing_status: assembly?.wing_status,
            other_aircraft_msn: assembly?.other_aircraft_msn
        }
        if(assembly.major_assembly_type !== 'APU'){
            formData = {
                ...formData,
                position:assembly.position
            }
        }
        setLinkAssembly({modal:true, data:{type:assemblyTypeObj[assembly.major_assembly_type], label:assembly.major_assembly_type}, editObj:formData, type:'edit'})
    }
    let filterOption = Object.assign({},maFilterOps)
    filterOption={
        ...filterOption,
        asset_type: {
            ...filterOption.asset_type,
            options: assetInfoData?.aircraft_type?.has_propeller && assetInfoData?.aircraft_type?.has_apu ?
                filterOption.asset_type.options :
                assetInfoData?.aircraft_type?.has_propeller && !assetInfoData?.aircraft_type?.has_apu ?
                    filterOption.asset_type.options.filter(item => item?.value !== 3) :
                    filterOption.asset_type.options.filter(item => item?.value !== 5)
        }
    }
    const checkUnlinkPermission =(majorAssembly )=>{
        setLoading(true)
        globalGetService(`console/aircraft/${assetInfoData?.slug}/billable-lease/`,{asset_id:majorAssembly?.id ,asset_type:assemblyTypeObj[majorAssembly.major_assembly_type]})
        .then(response=>{
            setLoading(false)
            // if(response.data.statusCode == '200' && getLocalStorageInfo()?.user?.permission?.contracts){
            if(response.data.statusCode == '428' && getLocalStorageInfo()?.user?.permission?.contracts){
                setActiveLeaseModal({modal:true, data:majorAssembly, response:response.data.message})
            }
            else{
                setUnlinkAssembly({modal:true, data:majorAssembly})
            }
        })
    }
    const validateData = (assembly, grouped, type) => {
        if (!grouped || (grouped && assembly?.type !== 4)) {
            if (type === 'link') {
                setLinkAssembly({ modal: true, data: assembly })
            } else {
                setAddEditAssembly({ modal: true, data: assembly })
            }
        } else {
            setLoading(true)
            globalGetService(`console/v2/aircraft/${assetInfoData?.slug}/can-add-link/`)
            .then(response => {
                    setLoading(false)
                    if (checkApiStatus(response)) {
                        if (response?.data?.data?.can_add_link) {
                            if (type === 'link') {
                                setLinkAssembly({ modal: true, data: assembly })
                            } else {
                                setAddEditAssembly({ modal: true, data: assembly })
                            }
                        } else {
                            setGroupError({ modal: true, data: assembly, type:type })
                        }
                    }
                })
        }
    }
    const onGroupLg =async()=>{
        try{
            setLoading(true)
            let response = await globalPostService(`console/v2/aircraft/${assetInfoData?.slug}/update-landing-gear-grouping/`, {is_grouped:lgGroupModal.flag})
            setLoading(false)
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                setLgGroupModal({})
                getMajorAssemblies()
            }
        }
        catch{
             setLoading(false)
        }
    }    
    return(
        <div style={{padding:'10px 10px 0px 10px', height:`${(window.innerHeight-210) - navTitleOffset}px`}}>
            { skeletonLoader ? <STableLoader count={7} size={7} />:
                <>
                    <Paper className="console-paper" style={{padding:'5px 10px', marginBottom: '2px'}}>
                        <Grid container spacing={1}>
                            <Grid item md={mtInstance? '6':8}>
                                <FilterComponent
                                    filter={filter}
                                    filterMenu={filterOption}
                                    getResponseBack={(applyFilter) => getMajorAssemblies('pageLoader', { ...applyFilter })}
                                />
                            </Grid>
                            <Grid item md={mtInstance? '6':4}>
                                <ul className="list-inline" style={{float:'right'}}>
                                      {mtInstance && majorAssemblyInfo.list?.filter(item=> item?.asset_type === 4)?.length?
                                        <li style={{fontSize:'13px', fontWeight:'bold'}} className="list-inline-item">
                                        <Checkbox checked={majorAssemblyInfo?.is_grouped} onChange={(e) => setLgGroupModal({modal:true, flag:e.target.checked})} color="primary" size="small" />
                                            Enable LG Grouping
                                     </li>:null}
                                {checkPermission('technical_specs', 'aircraft', 'U') ?
                                    <li className="list-inline-item">
                                        <AssemblyMenu btnLabel='Link Assembly' assetInfoData={assetInfoData} onClickAssembly={(assembly) => validateData(assembly, majorAssemblyInfo?.is_grouped, 'link')} />
                                    </li> : null}
                                    {checkPermission('technical_specs', 'aircraft', 'U') ?
                                    <li className="list-inline-item">
                                        <AssemblyMenu btnLabel='Add Assembly' assetInfoData={assetInfoData} onClickAssembly={(assembly) => validateData(assembly, majorAssemblyInfo?.is_grouped, 'add')} />
                                    </li>
                                    : null}
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper square >
                      <div style={{height:`${(window.innerHeight-270) - navTitleOffset}px`, overflow:'auto'}}>
                        <Table className='mui-table-format'>
                            <TableHead style={{position:'sticky', top:'0px'}}>
                                <TableRow>
                                    <TableCell style={{width:'100px'}}>Action(s)</TableCell>
                                    <TableCell>Serial Number</TableCell>
                                    <TableCell>Position</TableCell>
                                    <TableCell>Titled MSN</TableCell>
                                    <TableCell>Assigned MSN</TableCell>
                                    <TableCell>On Wing MSN</TableCell>
                                    <TableCell>Is Billable</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {majorAssemblyInfo?.list.map((majorAssembly, index) => 
                                    <TableRow>
                                        <TableCell align="left">
                                            <ul className="list-inline" style={{width:'100px'}}>
                                                {getLocalStorageInfo()?.is_records ?
                                                <li style={{cursor:'pointer', marginRight:'9px'}} className="list-inline-item" onClick={() => window.open(`${appConfig.domain.records}${majorAssembly.major_assembly_type.toLowerCase()}/${majorAssembly.slug}/data-room/technical/${majorAssembly?.records_details?.technical_records?.uuid }`, '_blank')}>
                                                   <Tooltip title='Stand-alone Records DataRoom' arrow>
                                                     <img style={{ width: '15px', marginBottom:'10px' }} src={imgStoragePath + 'phase-2/RecordsIcon.svg'} alt="Records DataRoom" />
                                                  </Tooltip>
                                                </li> : null}
                                                {checkPermission('technical_specs', 'aircraft', 'R') ?
                                                <li style={{cursor:'pointer'}} className="list-inline-item" onClick={() => window.open(`/technical-specification/${majorAssembly.major_assembly_type.toLowerCase()}/${majorAssembly.slug}/basic-details`, '_blank')}>
                                                    <Tooltip title="View Details" arrow>
                                                        <VisibilityIcon color="primary" fontSize="small" />
                                                    </Tooltip>
                                                </li> : null}
                                                {checkPermission('technical_specs', 'aircraft', 'U') ?
                                                <li style={{cursor:'pointer'}} className="list-inline-item" onClick={() => onEditAssembly(majorAssembly)}>
                                                    <Tooltip title="Edit Linking Flow" arrow>
                                                        <EditIcon color="primary" fontSize="small" />
                                                    </Tooltip>
                                                </li> : null}
                                                {checkPermission('technical_specs', 'aircraft', 'U') ?
                                                <li style={{cursor:'pointer'}} className="list-inline-item" onClick={() => checkUnlinkPermission(majorAssembly)}>
                                                    <Tooltip title='Unlink Assembly' arrow>
                                                        <DeleteOutlineIcon color="secondary" fontSize="small" />
                                                    </Tooltip>
                                                </li>: null}
                                            </ul>
                                        </TableCell>
                                        <TableCell>
                                            { majorAssembly?.asset_type?.name ?<span style={{fontSize:'11px'}}>{majorAssembly.asset_type.name}</span>:null}
                                            <p>{majorAssembly?.major_assembly_name||''}</p>
                                            { majorAssembly?.is_grouped && mtInstance? <div style={{color:"black !important"}} className="grouped-lg">Grouped LG</div>:null}
                                        </TableCell>
                                        <TableCell >{majorAssembly?.position?.label||'--'}
                                        {
                                            majorAssembly?.sub_assembly?.name ?<>
                                            <br/>
                                            <span className="chip-sub-asmbly"> {majorAssembly?.sub_assembly?.name } </span>
                                            </>
                                            : null
                                        }
                                        </TableCell>
                                        <TableCell>
                                            <span style={{ fontSize: '11px' }}>{majorAssembly?.titled_aircraft?.aircraft_type?.name || null}</span>
                                            <p> {
                                                majorAssembly?.titled_aircraft?.name ?
                                                    assetInfoData?.slug !== majorAssembly?.titled_aircraft?.slug ?
                                                        <span className="link-cls" style={{ color: 'blue' }} onClick={() => window.open(`/technical-specification/aircraft/${majorAssembly?.titled_aircraft?.slug}/basic-details`, '_blank')}>  {majorAssembly?.titled_aircraft?.name} </span> :
                                                        majorAssembly?.titled_aircraft?.name
                                                    : '--'}</p>
                                        </TableCell>
                                        <TableCell>
                                            <span style={{ fontSize: '11px' }}>{majorAssembly?.assigned_aircraft?.aircraft_type?.name || null}</span>
                                            <p> {
                                                majorAssembly?.assigned_aircraft?.name ?
                                                    assetInfoData?.slug !== majorAssembly?.assigned_aircraft?.slug ?
                                                        <span className="link-cls" style={{ color: 'blue' }} onClick={() => window.open(`/technical-specification/aircraft/${majorAssembly?.assigned_aircraft?.slug}/basic-details`, '_blank')}>  {majorAssembly?.assigned_aircraft?.name} </span> :
                                                        majorAssembly?.assigned_aircraft?.name
                                                    : '--'}</p>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip arrow title={majorAssembly?.other_aircraft_msn ? 'Other MSN' : ''}>
                                                {majorAssembly?.on_wing_status === true && majorAssembly?.on_other_aircraft_status !== true  ? <div style={{ display: 'inline-block' }}>
                                                    <span style={{ fontSize: '11px' }}>{majorAssembly?.on_wing_aircraft?.aircraft_type?.name || null}</span>
                                                    <p> {
                                                        majorAssembly?.on_wing_aircraft?.name ?
                                                            assetInfoData?.slug !== majorAssembly?.on_wing_aircraft?.slug ?
                                                                <span className="link-cls" style={{ color: 'blue' }} onClick={() => window.open(`/technical-specification/aircraft/${majorAssembly?.on_wing_aircraft?.slug}/basic-details`, '_blank')}>  {majorAssembly?.on_wing_aircraft?.name} </span> :
                                                                majorAssembly?.on_wing_aircraft?.name
                                                            : '--'}</p>
                                                </div> :
                                                <div>
                                                   {majorAssembly?.on_wing_status !== true && majorAssembly?.on_other_aircraft_status === true && majorAssembly?.other_aircraft_msn || '--'}
                                                </div>}
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <p>{majorAssembly?.is_billable ? 'Yes':'No'}</p>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                          { !majorAssemblyInfo?.list?.length ?<div className="text-center"><EmptyCollection title="No records found" /></div>:null}
                      </div>
                    </Paper>
                </>
            }
            { addEditAssembly.modal ?
                <AddAssembly
                recordsPermission={majorAssemblyInfo?.permission}
                    assetInfoData={assetInfoData}
                    addEditAssembly={addEditAssembly}
                    assetHasLgSubAssemblies={assetHasLgSubAssemblies}
                    toggleModalFn={() => setAddEditAssembly({modal:false, data:null})}
                    getResponseBack={() => getMajorAssemblies('pageLoader')}
                />:null
            }
            { linkAssembly.modal ?
                <LinkAssembly
                recordsPermission={majorAssemblyInfo?.permission}
                    showOffWingStatus={linkAssembly?.editObj?.on_wing_aircraft?.slug === assetInfoData?.slug}
                    assetInfoData={assetInfoData}
                    linkAssembly={linkAssembly}
                    assetHasLgSubAssemblies={assetHasLgSubAssemblies}
                    toggleModalFn={() => setLinkAssembly({modal:false, data:null})}
                    getResponseBack={() => {setLinkAssembly({modal:false, data:null}) ;getMajorAssemblies('pageLoader')}}
                />:null
            }
            { unlinkAssembly.modal ?
                <UnlinkAssembly 
                recordsPermission={majorAssemblyInfo?.permission}
                    showOffWingStatus={unlinkAssembly?.data?.on_wing_aircraft?.slug === assetInfoData?.slug}
                    assetInfoData={assetInfoData}
                    unlinkAssembly={unlinkAssembly}
                    toggleModalFn={() => setUnlinkAssembly({modal:false, data:null})}
                    getResponseBack={() => getMajorAssemblies('pageLoader')}
                />:null
            }
            { lgGroupModal?.modal ?
                <DeletePopUp 
                    modal={lgGroupModal.modal}
                    title={`This will ${lgGroupModal?.flag ?'Group':'Ungroup'} all the LG`}
                    content={`Are you sure, you want to ${lgGroupModal?.flag ?'Group':'Ungroup'} all the LG?`}
                    confirmColor='primary'
                    confirmText='Proceed'
                    toggleModalFn={() => setLgGroupModal({ modal: false, flag: null })}
                    deleteRecordFn={onGroupLg}
                
                />:null
            }
            {
                groupError?.modal ?
                 <DeletePopUp 
                    modal={groupError.modal}
                    title={`Unable to ${groupError?.type === 'link'?'Link':"Add"} `}
                    content={`MSN ${assetInfoData?.serial_number} already has required number of landing gears on it, Kindly unlink any one to continue.`}
                    confirmColor='primary'
                    confirmText='Okay'
                    deleteRecordFn={() => setGroupError({ modal: false, modal: null })}
                    singleButton='singleButton'
                
                />:null
            }
            {
                activeLeaseModal?.modal ?
                <ActiveLeasePopUp
                modal={activeLeaseModal.modal}
                title='Active Lease Alert'
                confirmText='Continue'
                content={activeLeaseModal?.response || "This Major assembly has an active lease."}
                toggleModalFn={() => setActiveLeaseModal({ modal: false, data: null })}
                submitFn={(reason)=>{setActiveLeaseModal({modal:false}); setUnlinkAssembly({modal:true, data:activeLeaseModal.data, emptyReason:reason}) }}
            /> : null
            }
            { isLoading ? <PageLoader/>:null}
        </div>
    )
}
export default withRouter(MajorAssemblies);